/* ═══════════════════════════════════════════════════════════
   ZERO ORAL — zero-waitlist.js
   Popup behavior: show logic, Klaviyo API submit, accessibility.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var COOKIE_KEY    = 'zo_waitlist_seen';
  var SUPPRESS_DAYS = 7;          /* days between auto-shows after close */
  var MOBILE_DELAY  = 8000;       /* ms before auto-show on mobile */
  var el            = document.getElementById('zo-waitlist');

  if (!el) return;

  var klaviyoKey    = el.dataset.klaviyoKey  || '';
  var klaviyoList   = el.dataset.klaviyoList || '';

  /* ── Helpers ── */
  function setCookie (name, days) {
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=1; expires=' + exp + '; path=/; SameSite=Lax';
  }
  function hasCookie (name) {
    return document.cookie.split(';').some(function (c) {
      return c.trim().startsWith(name + '=');
    });
  }
  function shouldShow () {
    return !hasCookie(COOKIE_KEY);
  }

  /* ── Open / Close ── */
  window.zWaitlistOpen = function () {
    if (!el) return;
    el.classList.add('zo-wl--open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    /* Focus the email input for accessibility */
    setTimeout(function () {
      var inp = document.getElementById('zo-wl-email');
      if (inp) inp.focus();
    }, 400);
  };

  window.zWaitlistClose = function () {
    if (!el) return;
    el.classList.remove('zo-wl--open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setCookie(COOKIE_KEY, SUPPRESS_DAYS);
  };

  /* ── Keyboard: ESC to close ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && el.classList.contains('zo-wl--open')) {
      zWaitlistClose();
    }
  });

  /* ── Auto-show logic ── */
  function initAutoShow () {
    if (!shouldShow()) return;
    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (isMobile) {
      /* Mobile: show after MOBILE_DELAY ms */
      setTimeout(function () {
        if (shouldShow()) zWaitlistOpen();
      }, MOBILE_DELAY);
    } else {
      /* Desktop: exit intent — mouseleave top of viewport */
      var triggered = false;
      document.addEventListener('mouseleave', function (e) {
        if (triggered) return;
        if (e.clientY <= 0) {
          triggered = true;
          if (shouldShow()) zWaitlistOpen();
        }
      });
    }
  }

  /* ── Klaviyo subscribe via Client API ── */
  function klaviyoSubscribe (email, onSuccess, onError) {
    if (!klaviyoKey || klaviyoKey === 'XXXXXX') {
      /* Dev mode: simulate success */
      console.warn('[ZERO] Klaviyo key not configured. Simulating success.');
      onSuccess();
      return;
    }

    var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoKey;
    var payload  = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type:       'profile',
              attributes: { email: email }
            }
          }
        }
      }
    };
    if (klaviyoList && klaviyoList !== 'XXXXXX') {
      payload.data.attributes.list = { data: { type: 'list', id: klaviyoList } };
    }

    fetch(endpoint, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision':     '2023-10-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (res.ok || res.status === 202) { onSuccess(); }
        else { onError(); }
      })
      .catch(function () { onError(); });
  }

  /* ── Form submit ── */
  var form    = document.getElementById('zo-wl-form');
  var emailEl = document.getElementById('zo-wl-email');
  var submitEl= document.getElementById('zo-wl-submit');
  var errorEl = document.getElementById('zo-wl-error');
  var successEl = document.getElementById('zo-wl-success');
  var formState = document.getElementById('zo-wl-form-state');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailEl ? emailEl.value : '').trim();

      /* Validate */
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errorEl) errorEl.classList.add('visible');
        if (emailEl) emailEl.focus();
        return;
      }
      if (errorEl) errorEl.classList.remove('visible');

      /* Loading state */
      if (submitEl) { submitEl.disabled = true; submitEl.textContent = 'Joining…'; }

      klaviyoSubscribe(
        email,
        /* success */
        function () {
          setCookie(COOKIE_KEY, SUPPRESS_DAYS);
          if (formState)  formState.style.display = 'none';
          if (successEl)  successEl.style.display = 'block';
          /* Auto-close after 4 seconds */
          setTimeout(function () { zWaitlistClose(); }, 4000);
        },
        /* error */
        function () {
          if (submitEl) { submitEl.disabled = false; submitEl.textContent = 'Join Early Access'; }
          if (errorEl)  { errorEl.textContent = 'Something went wrong. Please try again.'; errorEl.classList.add('visible'); }
        }
      );
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    /* Small delay so page renders fully first */
    setTimeout(initAutoShow, 600);
  });

}());
